<div class="footer">
  <div class="rights">Copyright 2021 © EasyRecipes. All Rights Reserved.</div>
</div>
